module.exports = __webpack_public_path__ + "img/member_trading_record_icon_431003.27c07f4f.jpg";